import Crud from '../views/UnidadeMaterial/Crud'
import Entity from '../views/UnidadeMaterial/Add'

let routes = {
    path: '/unidade_materiais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/unidade_materiais/add',
            name: 'NewUnidadeMaterial',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Unidades Materiais',
                breadcrumb: [
                    {
                        text: 'Unidade material',
                        active: false,
                        to: '/unidade_materiais',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/unidade_materiais/edit/:id?',
            name: 'EditUnidadeMaterial',
            component: Entity,
            meta: {
                pageTitle: 'Editar Unidades Materiais',
                breadcrumb: [
                    {
                        text: 'Unidade material',
                        active: false,
                        to: '/unidade_materiais',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/unidade_materiais',
            name: 'list-unidade_materiais',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Unidades Materiais',
                breadcrumb: [
                    {
                        text: 'Unidades Materiais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
